import {Action, Dispatch} from "@reduxjs/toolkit"
import {STANDARD_TEMPLATE} from "@manifest/constants"
import {TemplateSettingsModel} from "../../models/templates"

export const SET_TEMPLATE = "SET_TEMPLATE"

interface SetTemplateAction {
    type: typeof SET_TEMPLATE
    mainTemplate: string
    fallbackTemplate: string
}

export type TemplateSettingsStateModel = TemplateSettingsModel

export const initialTemplateState: TemplateSettingsStateModel = {
    mainTemplate: STANDARD_TEMPLATE,
    fallbackTemplate: STANDARD_TEMPLATE,
}

export const setTemplateAction = (mainTemplate: string, fallbackTemplate: string): SetTemplateAction => {
    return {
        type: SET_TEMPLATE,
        mainTemplate,
        fallbackTemplate,
    }
}

const reducer = (state: TemplateSettingsStateModel = initialTemplateState, action: SetTemplateAction) => {
    switch (action.type) {
        case SET_TEMPLATE:
            return {
                mainTemplate: action.mainTemplate,
                fallbackTemplate: action.fallbackTemplate,
            }
        default:
            return state
    }
}

export const updateTemplate = (dispatch: Dispatch, templateConfig: TemplateSettingsModel) => {
    dispatch<Action>(setTemplateAction(templateConfig.mainTemplate, templateConfig.fallbackTemplate))
}

export default reducer
